const productMappings = new Map([
  ['hawksoftcloud', 1],
  ['rater', 2],
  ['esignature', 3],
  ['texting', 5],
  ['selfcerts', 7],
  ['agentportal', 9]
]);
export default {
  methods: {
    getProductId (productName) {
      return productMappings.get(productName.toLowerCase());
    }
  }
}
;
